export const ENDPOINTS_TRANSLATIONS = {
    GET_ALL: '/api/translations',
    SAVE: '/api/translations',
  };